// extracted by mini-css-extract-plugin
export var active = "Header-module--active--88120";
export var btn = "Header-module--btn--24fea";
export var core = "Header-module--core--eb7cd";
export var fixed = "Header-module--fixed--7150d";
export var grid = "Header-module--grid--884e3";
export var home = "Header-module--home--7bf9c";
export var logo = "Header-module--logo--577ec";
export var navList = "Header-module--nav-list--9a082";
export var visible = "Header-module--visible--5888f";